import { Observable } from 'rxjs/Observable';
import { EventSource } from './eventSource';

import { Photo } from './interfaces'
import { nullSorter } from './sort';

export interface Vip {
    name: string;
    title: string;
    email?: string;
    info?: string;
    avatar: Photo;
}

export class EventVip {

    private es: EventSource;

    constructor(eventSource: EventSource) {
        this.es = eventSource;
    }

    public observeVips(): Observable<Array<Vip>> {
        return this.es.pluckData(this.es.observeVipPage(), ['vips'])
            .map(vip => Object.keys(vip).map((key, idx) => {
                vip[key].key = key;
                vip[key].sortKey = vip[key].sortKey && !isNaN(parseInt(vip[key].sortKey)) ? parseInt(vip[key].sortKey) : idx;
                return vip[key] 
            }).filter(x => x)).map(data => data.sort(nullSorter));
    }

    public observePrimaryFaqPhoto(): Observable<Photo> {
        return this.es.observePrimaryPhoto(this.es.observeVipPage());
    }
    
    public observePrimaryFaqPhotoHorizontal(): Observable<Photo> {
        return this.es.observePrimaryPhotoHorizontal(this.es.observeVipPage());
    }
}
